import script from "./CopyrightHolder.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyrightHolder.vue?vue&type=script&setup=true&lang=js"

import "./CopyrightHolder.vue?vue&type=style&index=0&id=37f8b96c&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_mcn_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37f8b96c"]])

export default __exports__